<template>
  <div>
    <q-dialog v-model="valor">
      <q-card
        class="text-brand-5 text-weight-bold"
        style="height: 500px; max-width: 900px; width: 900px"
      >
        <q-card-section>
          <div class="text-h6">{{ titulo }}</div>
        </q-card-section>
        <q-separator />

        <q-card-section class="row">
          <div class="row" v-if="aplicacaoExecutando">
            <img v-show="biometria" src="" id="image" alt="" />
            <div class="col q-ml-lg" style="height: 300px">
              <div class="row col-12" v-if="!biometria">
                <div class="row col-12 justify-center">
                  <p class="text-h6">
                    {{ mensagem }}
                  </p>
                </div>
                <div class="row col-12 q-mt-lg justify-center">
                  <q-circular-progress
                    v-if="loading"
                    indeterminate
                    rounded
                    size="70px"
                    color="primary"
                    class="q-mt-xl"
                  />
                </div>
              </div>
              <SelecaoDeDedo
                draggable
                @dedo="receberDedo"
                :limparDados="removerDedo"
                :dedosSelecionados="dedosSelecionados"
                :tipoBiometria="'verificacao'"
                v-if="!biometria && tipoBiometria == 'verificacao' && !loading"
              />
            </div>
          </div>
          <div v-else class="row col-12" style="height: 300px">
            <div class="row col-12">
              <q-icon
                class="row justify-center col-12"
                size="70px"
                name="error_outline"
              />
              <div class="row col-12 justify-center">
                <span
                  style="text-align: center"
                  class="text-h6 q-mt-sm"
                  v-html="mensagemErro"
                ></span>
                <a
                  target="blank"
                  style="cursor: pointer"
                  href="https://sites.google.com/multpex.com.br/basedeconhecimento/d%C3%BAvidas-administrativas/download-e-instala%C3%A7%C3%A3o-leitor-biom%C3%A9trico-web"
                  ><q-icon size="50px" name="book" color="brand-1"
                /></a>
              </div>
            </div>
          </div>
        </q-card-section>

        <q-separator />
        <q-card-actions align="right" class="q-mt-lg">
          <div v-if="aplicacaoExecutando" class="row col justify-start q-ml-md">
            <div>
              <div class="row items-center">
                <div
                  style="
                    background-color: green;
                    width: 12px;
                    height: 12px;
                    border-radius: 3px;
                  "
                ></div>
                <span class="q-ml-xs">Dedos Cadastrados</span>
              </div>
            </div>
          </div>
          <q-btn
            icon="close"
            label="Fechar"
            color="negative"
            no-caps
            v-close-popup
          />
          <div class="q-gutter-x-sm q-ml-xs">
            <q-btn
              v-if="base64Images.length > 0"
              icon="refresh"
              label="Refazer"
              color="primary"
              no-caps
              @click="refazer()"
            />
            <q-btn
              v-if="base64Images.length == 0 && aplicacaoExecutando"
              :disable="biometria"
              icon="fingerprint"
              label="Coletar Biometria"
              color="positive"
              no-caps
              @click="coletarBiometria()"
            />
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import SelecaoDeDedo from "../../../biometria/components/SelecaoDeDedo.vue";

export default {
  name: "BiometriaPT",
  components: { SelecaoDeDedo },
  props: [
    "modal",
    "matricula",
    "unidadeId",
    "titulo",
    "tipoBiometria",
    "responsavelId",
  ],
  emits: ["negativePrint", "resultadoVerificacao"],
  setup(props, { emit }) {
    const quasar = useQuasar();
    const store = useStore();
    let valor = ref(false);

    let dedoSelecionado = ref(null);
    let mensagem = ref("Clique em Coletar Biometria para iniciar verificação.");
    let biometria = ref(false);
    let removerDedo = ref(0);
    const base64Images = ref([]);
    let loading = ref(false);
    const negativePrint = ref("");
    const mensagemErro = ref("");
    const aplicacaoExecutando = ref(false);
    const funcionarioId = ref(null);
    const dedosSelecionados = ref("");

    const buscarFuncionarioId = async () => {
      try {
        const funcionarioResponse = await store.dispatch(
          "biometria/buscarFuncionarioPorSap",
          {
            unidadeId: props.unidadeId || 1,
            sap: props.matricula,
          }
        );

        const funcionarios = funcionarioResponse.data?.resultado?.dados || [];
        const funcionario = funcionarios.find(
          (func) =>
            func.matricula === props.matricula || func.sap === props.matricula
        );

        if (!funcionario || !funcionario.funcionarioId) {
          throw new Error("Funcionário não encontrado ou sem ID válido");
        }

        funcionarioId.value = funcionario.funcionarioId;

        return funcionario.funcionarioId;
      } catch (error) {
        console.error("Erro ao buscar funcionário:", error);
        quasar.notify({
          message: "Funcionário não encontrado na base de dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return null;
      }
    };

    const coletarBiometria = async () => {
      loading.value = true;

      try {
        // buscar o funcionarioId primeiro
        const funcId = await buscarFuncionarioId();
        if (!funcId) {
          loading.value = false;
          return;
        }

        // fazer verificacoes de health primeiro
        try {
          await store.dispatch("biometria/verificarHealthBiometria");
        } catch (error) {
          console.warn("Erro no health check:", error);
        }

        try {
          await store.dispatch("biometria/verificarHealthCheckBiometria");
        } catch (error) {
          console.warn("Erro no healthcheck:", error);
        }

        // buscar fingers do funcionario usando o funcionarioId correto
        try {
          await store.dispatch("biometria/buscarFingersUsuario", {
            funcionarioId: funcId,
          });
        } catch (error) {
          console.warn("Erro ao buscar fingers:", error);
        }

        // coletar a biometria
        let response = await store.dispatch("biometria/getIdentification");
        if (!response.data.sucesso) {
          quasar.notify({
            message: response.data.mensagemErro,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
          loading.value = false;
          return;
        }

        let fingerPrint = response.data.imagemDigital;
        negativePrint.value = response.data.imagemDigitalNegativa;

        if (fingerPrint) {
          let image = document.getElementById("image");
          biometria.value = true;
          image.src = "data:image/png;base64, " + negativePrint.value;
          base64Images.value.push(fingerPrint);
        }

        loading.value = false;

        // verificar a biometria automaticamente
        await verificarBiometria();
      } catch (error) {
        console.error("Erro ao coletar biometria:", error);
        quasar.notify({
          message:
            error.response?.data?.mensagemErro || "Erro ao coletar biometria",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        loading.value = false;
      }
    };

    const verificarBiometria = async () => {
      try {
        if (!funcionarioId.value) {
          throw new Error("ID do funcionário não encontrado");
        }

        const response = await store.dispatch(
          "biometria/identificarBiometriaDigital",
          {
            userId: funcionarioId.value,
            base64Image: base64Images.value[0],
            imageWidth: 320,
            imageHeight: 480,
            imageResolution: 500,
          }
        );

        emit("negativePrint", negativePrint.value);

        const isSuccess =
          response.data?.success === true ||
          response.data === true ||
          (typeof response.data === "object" &&
            response.data?.resultado === true) ||
          response.data === 1 ||
          (typeof response.data === "number" && response.data > 0);

        if (isSuccess) {
          quasar.notify({
            message: "Biometria verificada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
          emit("resultadoVerificacao", true);
          valor.value = false;
          return;
        }

        throw new Error("Biometria não foi identificada corretamente");
      } catch (error) {
        console.error("Erro ao verificar biometria:", error);
        quasar.notify({
          message:
            "A biometria verificada não coincide com a digital verificada, faça novamente o processo de verificação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        emit("resultadoVerificacao", false);
        refazer();
      }
    };

    const getVersion = async () => {
      try {
        const response = await store.dispatch("biometria/getVersion");

        if (validarVersao(response.data.versao)) {
          aplicacaoExecutando.value = true;
          receberDedosCadastrados();
          return;
        }

        mensagemErro.value =
          "Versão desatualizada, por favor faça o download da nova versão.";
      } catch (error) {
        mensagemErro.value =
          "Aplicação desktop parada, favor iniciar antes de começar as rotinas de verificação. Se não tiver a aplicação instalada, favor consultar procedimento para download";
      }
    };

    const refazer = () => {
      removerDedo.value++;
      let image = document.getElementById("image");
      if (image) {
        image.src = "";
      }
      mensagem.value = "Clique em Coletar Biometria para iniciar verificação.";
      biometria.value = false;
      base64Images.value = [];
      loading.value = false;
      negativePrint.value = "";
    };

    const receberDedo = (dedo) => {
      dedoSelecionado.value = dedo;
      mensagem.value = `Posicione o ${dedo.label} no leitor e aguarde`;
      coletarBiometria();
    };

    const receberDedosCadastrados = async () => {
      try {
        if (!funcionarioId.value) {
          const funcId = await buscarFuncionarioId();
          if (!funcId) return;
        }

        const response = await store.dispatch(
          "biometria/receberDedosCadastradosNew",
          {
            id: funcionarioId.value,
          }
        );
        dedosSelecionados.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const validarVersao = (version) => {
      const versaoRegex = /^1\.(\d+)\.(\d+)$/;
      return versaoRegex.test(version);
    };

    watch(
      () => props.modal,
      (newValue) => {
        if (newValue) {
          valor.value = true;
          removerDedo.value++;
          biometria.value = false;
          base64Images.value = [];
          negativePrint.value = "";
          loading.value = false;
          funcionarioId.value = null;
          getVersion();
          mensagem.value =
            "Clique em Coletar Biometria para iniciar o processo e coloque o dedo no leitor para realizar a coleta.";
        }
      },
      { immediate: true }
    );

    // detectar quando o modal é fechado e resetar o estado no componente pai
    watch(
      () => valor.value,
      (newValue) => {
        if (!newValue && props.modal) {
          emit("resultadoVerificacao", false);
        }
      }
    );

    return {
      biometria,
      valor,
      mensagem,
      removerDedo,
      refazer,
      coletarBiometria,
      receberDedo,
      base64Images,
      verificarBiometria,
      loading,
      negativePrint,
      getVersion,
      mensagemErro,
      aplicacaoExecutando,
      receberDedosCadastrados,
      dedosSelecionados,
      validarVersao,
    };
  },
};
</script>

<style scoped>
#image {
  height: 300px;
  width: 200px;
}
.alinhamento {
  text-align: center;
}
a {
  text-decoration: none;
}
</style>
